/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} getFeedbackSiteSelectorDialogLoadedParams

**/
/**
 * Name: Get feedback - site selector dialog loaded. Evid: 1117.
 * Event description: get feedback site selector dialog successfully loaded.


 * @param {getFeedbackSiteSelectorDialogLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackSiteSelectorDialogLoaded = function (params) {
    return { evid: 1117, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackOnOffFilterOnCommentListParams
* @property {string} desktop_filter_state - on/off
* @property {string} mobile_filter_state - on/off
* @property {GUID} msid - msid
* @property {string} resolved_filter_state - on/off
**/
/**
 * Name: Get feedback - on / off filter on comment list. Evid: 1113.
 * Event description: clicks on/off on filter in comment list at get feedback view-comments page.

 * desktop_filter_state - Type: string. Desc: on/off
 *
 * mobile_filter_state - Type: string. Desc: on/off
 *
 * msid - Type: guid. Desc: msid
 *
 * resolved_filter_state - Type: string. Desc: on/off
 * @param {getFeedbackOnOffFilterOnCommentListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackOnOffFilterOnCommentList = function (params) {
    return { evid: 1113, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackAddACommentButtonParams
* @property {string} breakpoint - breakpoint
* @property {GUID} contactId - Contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {GUID} msid - msid
* @property {string} origin - source name
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - add a comment button. Evid: 1115.
 * Event description: clicked on add a comment.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * contactId - Type: guid. Desc: Contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackAddACommentButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackAddACommentButton = function (params) {
    return { evid: 1115, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackCopyLinkLinkCouldNotBeGeneratedParams
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get feedback - copy link - Link could not be generated. Evid: 1121.
 * Event description: clicked on get feedback copy share link from 'origin' and the link could not be generated.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackCopyLinkLinkCouldNotBeGeneratedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackCopyLinkLinkCouldNotBeGenerated = function (params) {
    return { evid: 1121, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackResolveCommentParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {string} commentStatus - comment_status
* @property {string} editorVersion - editor/editorx
* @property {GUID} msid - msid
* @property {string} origin - page name
**/
/**
 * Name: Get feedback - resolve comment. Evid: 1109.
 * Event description: Clicked to resolve to a comment.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 * @param {getFeedbackResolveCommentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackResolveComment = function (params) {
    return { evid: 1109, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackEditCommentOrReplyParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {string} commentStatus - comment_status
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/commenter
* @property {string} mode - desktop/mobile
* @property {GUID} msid - msid
* @property {string} origin - page name
* @property {string} page_id - homepage/other
* @property {GUID} response_id - Response guid for each response
* @property {number} response_number - Number of the response in comment
* @property {string} text - text in comment/reply
* @property {string} type - comment/reply
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - edit comment or reply. Evid: 1110.
 * Event description: finish editing a comment or reply.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * mode - Type: string. Desc: desktop/mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 *
 * page_id - Type: string. Desc: homepage/other
 *
 * response_id - Type: guid. Desc: Response guid for each response
 *
 * response_number - Type: numeric. Desc: Number of the response in comment
 *
 * text - Type: string. Desc: text in comment/reply
 *
 * type - Type: string. Desc: comment/reply
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackEditCommentOrReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackEditCommentOrReply = function (params) {
    return { evid: 1110, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackDeleteCommentOrResponseParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {string} commentStatus - comment_status
* @property {GUID} contactId - ContactId (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/commenter
* @property {GUID} msid - msid
* @property {string} origin - page name
* @property {string} page_id - page_id
* @property {GUID} response_id - Response guid for each response
* @property {string} type - comment/reply
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - delete comment or response. Evid: 1111.
 * Event description: Click to delete comment or response.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * contactId - Type: guid. Desc: ContactId (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 *
 * page_id - Type: string. Desc: page_id
 *
 * response_id - Type: guid. Desc: Response guid for each response
 *
 * type - Type: string. Desc: comment/reply
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackDeleteCommentOrResponseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackDeleteCommentOrResponse = function (params) {
    return { evid: 1111, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickOnHeaderParams
* @property {string} clickType - click type
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/commenter
* @property {GUID} msid - msid
* @property {string} page_id - page_id
**/
/**
 * Name: Get Feedback - Click on header. Evid: 1131.
 * Event description: Fires when user (client or partner) clicks on header.

 * clickType - Type: string. Desc: click type
 *
 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * msid - Type: guid. Desc: msid
 *
 * page_id - Type: string. Desc: page_id
 * @param {getFeedbackClickOnHeaderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickOnHeader = function (params) {
    return { evid: 1131, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickOnDropdownMenuParams
* @property {string} editorVersion - editor/edix
* @property {string} user_type - commenter/owner/contributor
* @property {GUID} msid - msid
**/
/**
 * Name: Get Feedback - Click on Dropdown Menu. Evid: 1125.
 * Event description: Fires when user clicks on the dropdown menu to filter comments.

 * editorVersion - Type: string. Desc: editor/edix
 *
 * user_type - Type: string. Desc: commenter/owner/contributor
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackClickOnDropdownMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickOnDropdownMenu = function (params) {
    return { evid: 1125, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackErrorMessageParams
* @property {GUID} msid - msid
**/
/**
 * Name: Get feedback - error message. Evid: 1134.
 * Event description: Fires when error in the get feedback link.

 * msid - Type: guid. Desc: msid
 * @param {getFeedbackErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackErrorMessage = function (params) {
    return { evid: 1134, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackHideOrShowCommentListParams
* @property {string} action - Hide or show comments
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - commenter/owner/contributor
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get feedback - hide or show comment list. Evid: 1112.
 * Event description: clicked to hide/show comment list on get feedback view-comments page.

 * action - Type: string. Desc: Hide or show comments
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: commenter/owner/contributor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackHideOrShowCommentListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackHideOrShowCommentList = function (params) {
    return { evid: 1112, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickOnSendParams
* @property {number} countInvitationsContacts - count invitations to contacts
* @property {number} countInvitations - Count of invitations sent
* @property {GUID} msid - msid
* @property {string} note - notes of the share dialog
* @property {string} origin - source name
**/
/**
 * Name: Get Feedback - Click on Send. Evid: 1122.
 * Event description: Fires when user sends get feedback notification.

 * countInvitationsContacts - Type: numeric. Desc: count invitations to contacts
 *
 * countInvitations - Type: numeric. Desc: Count of invitations sent
 *
 * msid - Type: guid. Desc: msid
 *
 * note - Type: string. Desc: notes of the share dialog
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackClickOnSendParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickOnSend = function (params) {
    return { evid: 1122, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClicksBackParams
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get Feedback - Clicks Back. Evid: 1124.
 * Event description: FIres when user clicks back in the dialogue box.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackClicksBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClicksBack = function (params) {
    return { evid: 1124, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackChooseModeParams
* @property {string} breakpoint - breakpoint
* @property {string} device - editorx device
* @property {string} editorVersion - {editor/editorx]
* @property {string} user_type - user_type
* @property {string} mode - {Desktop/Mobile}
* @property {GUID} msid - msid
**/
/**
 * Name: Get Feedback - Choose Mode. Evid: 1128.
 * Event description: Fires when user (client or partner) choose a mode.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * device - Type: string. Desc: editorx device
 *
 * editorVersion - Type: string. Desc: {editor/editorx]
 *
 * user_type - Type: string. Desc: user_type
 *
 * mode - Type: string. Desc: {Desktop/Mobile}
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackChooseModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackChooseMode = function (params) {
    return { evid: 1128, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackViewCommentsButtonParams
* @property {string} editorVersion - editor/editorx/adi/standard
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get feedback - view comments button. Evid: 1105.
 * Event description: clicked on get feedback view comments from 'origin'.

 * editorVersion - Type: string. Desc: editor/editorx/adi/standard
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackViewCommentsButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackViewCommentsButton = function (params) {
    return { evid: 1105, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackViewCommentParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {string} commentStatus - comment_status
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/commenter
* @property {GUID} msid - msid
* @property {string} origin - page name
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - view comment. Evid: 1107.
 * Event description: Click to view the comment.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackViewCommentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackViewComment = function (params) {
    return { evid: 1107, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackViewCommentsPageLoadedParams
* @property {string} breakpoint - null
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/contributor
* @property {GUID} msid - msid
**/
/**
 * Name: Get feedback - view comments page loaded. Evid: 1106.
 * Event description: View comments page loaded.

 * breakpoint - Type: string.
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/contributor
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackViewCommentsPageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackViewCommentsPageLoaded = function (params) {
    return { evid: 1106, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackChoosePageParams
* @property {GUID} contactId - contact_id if any
* @property {string} device - editorx device
* @property {string} editorVersion - {editor/editorx]
* @property {string} user_type - owner/contributor/commenter
* @property {string} mode - {Desktop/Mobile/Tablet}
* @property {GUID} msid - msid
* @property {string} pageName - page name
**/
/**
 * Name: Get Feedback - Choose Page. Evid: 1130.
 * Event description: Fires when user (client or partner) choose a page.

 * contactId - Type: guid. Desc: contact_id if any
 *
 * device - Type: string. Desc: editorx device
 *
 * editorVersion - Type: string. Desc: {editor/editorx]
 *
 * user_type - Type: string. Desc: owner/contributor/commenter
 *
 * mode - Type: string. Desc: {Desktop/Mobile/Tablet}
 *
 * msid - Type: guid. Desc: msid
 *
 * pageName - Type: string. Desc: page name
 * @param {getFeedbackChoosePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackChoosePage = function (params) {
    return { evid: 1130, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackDialogLoadedParams
* @property {string} editorVersion - standard/Editor/ADI/EditorX
* @property {GUID} msid - msid dialog belongs to
* @property {string} origin - entry point name
**/
/**
 * Name: Get feedback - dialog loaded. Evid: 1102.
 * Event description: get feedback dialog successfully loaded.

 * editorVersion - Type: string. Desc: standard/Editor/ADI/EditorX
 *
 * msid - Type: guid. Desc: msid dialog belongs to
 *
 * origin - Type: string. Desc: entry point name
 * @param {getFeedbackDialogLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackDialogLoaded = function (params) {
    return { evid: 1102, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickEditReplyParams
* @property {string} breakpoint - breakpoint
* @property {string} click_type - click_type
* @property {string} commentStatus - comment_status
* @property {string} editorVersion - version
* @property {string} user_type - user_type
* @property {GUID} msid - msid
* @property {GUID} visitorId - visitorid
**/
/**
 * Name: Get Feedback - Click edit reply. Evid: 1133.
 * Event description: Tracks click on edit site.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * click_type - Type: string. Desc: click_type
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * editorVersion - Type: string. Desc: version
 *
 * user_type - Type: string. Desc: user_type
 *
 * msid - Type: guid. Desc: msid
 *
 * visitorId - Type: guid. Desc: visitorid
 * @param {getFeedbackClickEditReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickEditReply = function (params) {
    return { evid: 1133, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackEditProfileParams
* @property {string} comment_id - {}
* @property {string} mode - desktop/mobile
* @property {GUID} msid - msid
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get Feedback - Edit Profile. Evid: 1127.
 * Event description: Fires when user clicks on Edit Profile.

 * comment_id - Type: string. Desc: {}
 *
 * mode - Type: string. Desc: desktop/mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackEditProfileParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackEditProfile = function (params) {
    return { evid: 1127, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackDialogClosedParams
* @property {string} editorVersion - editor/editorx/standard/adi
* @property {GUID} msid - msid
**/
/**
 * Name: Get feedback - dialog closed. Evid: 1103.
 * Event description: clicked on close get feedback dialog.

 * editorVersion - Type: string. Desc: editor/editorx/standard/adi
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackDialogClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackDialogClosed = function (params) {
    return { evid: 1103, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackLightboxActionParams
* @property {string} action - got-it/close
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} light_box_guid - guid
* @property {string} light_box_name - name
* @property {GUID} msid - msid
* @property {string} origin - source name
* @property {GUID} visitorId - visitors guid
**/
/**
 * Name: Get feedback - lightbox action. Evid: 1114.
 * Event description: clicked on lightbox.

 * action - Type: string. Desc: got-it/close
 *
 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * light_box_guid - Type: string. Desc: guid
 *
 * light_box_name - Type: string. Desc: name
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 *
 * visitorId - Type: guid. Desc: visitors guid
 * @param {getFeedbackLightboxActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackLightboxAction = function (params) {
    return { evid: 1114, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickedCopyLinkParams
* @property {string} editorVersion - editor/editorx/standard/adi
* @property {string} user_type - owner/contributor
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get feedback - clicked copy link. Evid: 1104.
 * Event description: clicked on get feedback copy share link from 'origin'.

 * editorVersion - Type: string. Desc: editor/editorx/standard/adi
 *
 * user_type - Type: string. Desc: owner/contributor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackClickedCopyLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickedCopyLink = function (params) {
    return { evid: 1104, src: 80, endpoint: 'get-feedback', params: params };
};
/*event 1100 on project 'com.wixpress.get-feedback' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} getFeedbackSiteSelectorDialogSearchParams
* @property {string} text - text searched
**/
/**
 * Name: Get feedback - site selector dialog search. Evid: 1119.
 * Event description: search site in the site selector dialog.

 * text - Type: string. Desc: text searched
 * @param {getFeedbackSiteSelectorDialogSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackSiteSelectorDialogSearch = function (params) {
    return { evid: 1119, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClickOnOptionDropdownMenuParams
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - commenter/owner/contributor
* @property {GUID} msid - msid
* @property {string} option - option chosen
**/
/**
 * Name: Get Feedback - Click on option (dropdown menu). Evid: 1126.
 * Event description: Fires when user clicks on an option from the  dropdown menu to filter comments.

 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: commenter/owner/contributor
 *
 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: option chosen
 * @param {getFeedbackClickOnOptionDropdownMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClickOnOptionDropdownMenu = function (params) {
    return { evid: 1126, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackMoveACommentParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - owner/commenter
* @property {string} mode - desktop/mobile
* @property {GUID} msid - msid
* @property {string} origin - page name
* @property {string} page_id - homepage/other
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - move a comment. Evid: 1116.


 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * mode - Type: string. Desc: desktop/mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 *
 * page_id - Type: string. Desc: homepage/other
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackMoveACommentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackMoveAComment = function (params) {
    return { evid: 1116, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackDailogEntryPointParams
* @property {GUID} msid - What msid did they click on
* @property {string} origin - entry point name
**/
/**
 * Name: get feedback - dailog entry point. Evid: 1101.
 * Event description: All entry points to the get feedback dialog screen.

 * msid - Type: guid. Desc: What msid did they click on
 *
 * origin - Type: string. Desc: entry point name
 * @param {getFeedbackDailogEntryPointParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackDailogEntryPoint = function (params) {
    return { evid: 1101, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackSiteSelectorClickParams
* @property {string} click_type - click_type
* @property {GUID} msid - msid
**/
/**
 * Name: Get Feedback - Site Selector - Click. Evid: 1132.
 * Event description: Tracks click on the site selector..

 * click_type - Type: string. Desc: click_type
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackSiteSelectorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackSiteSelectorClick = function (params) {
    return { evid: 1132, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackAddCommentOrReplyParams
* @property {string} breakpoint - breakpoint
* @property {string} comment_id - {}
* @property {string} commentStatus - comment_status
* @property {GUID} contactId - ContactId (if any)
* @property {string} editorVersion - editor/editorx
* @property {boolean} emailInput - user input email?
* @property {string} user_type - owner/commenter
* @property {string} mode - desktop/mobile
* @property {GUID} msid - msid
* @property {string} origin - page name
* @property {string} page_id - homepage/other
* @property {GUID} response_id - Response guid for each response
* @property {number} response_number - Number of the response in comment
* @property {string} text - text in comment/reply
* @property {string} type - comment/reply
* @property {GUID} visitorId - {}
**/
/**
 * Name: Get feedback - add comment or reply. Evid: 1108.
 * Event description: finish adding comment or reply.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * comment_id - Type: string. Desc: {}
 *
 * commentStatus - Type: string. Desc: comment_status
 *
 * contactId - Type: guid. Desc: ContactId (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * emailInput - Type: bool. Desc: user input email?
 *
 * user_type - Type: string. Desc: owner/commenter
 *
 * mode - Type: string. Desc: desktop/mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page name
 *
 * page_id - Type: string. Desc: homepage/other
 *
 * response_id - Type: guid. Desc: Response guid for each response
 *
 * response_number - Type: numeric. Desc: Number of the response in comment
 *
 * text - Type: string. Desc: text in comment/reply
 *
 * type - Type: string. Desc: comment/reply
 *
 * visitorId - Type: guid. Desc: {}
 * @param {getFeedbackAddCommentOrReplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackAddCommentOrReply = function (params) {
    return { evid: 1108, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackClientSidePageLoadedParams
* @property {GUID} contactId - contact_id (if any)
* @property {string} editorVersion - editor/editorx
* @property {string} user_type - commenter/owner
* @property {GUID} visitor_id - guid
**/
/**
 * Name: Get feedback - client side page loaded. Evid: 1120.
 * Event description: Client-side / leave comments page loaded.

 * contactId - Type: guid. Desc: contact_id (if any)
 *
 * editorVersion - Type: string. Desc: editor/editorx
 *
 * user_type - Type: string. Desc: commenter/owner
 *
 * visitor_id - Type: guid. Desc: guid
 * @param {getFeedbackClientSidePageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackClientSidePageLoaded = function (params) {
    return { evid: 1120, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackChangePixelsHeaderParams
* @property {string} breakpoint - breakpoint
* @property {GUID} contactId - contact_id if any
* @property {string} device - editorx device
* @property {string} editorVersion - {editor/editorx]
* @property {string} user_type - user_type
* @property {string} mode - {Desktop/Mobile/Tablet}
* @property {GUID} msid - msid
**/
/**
 * Name: Get Feedback - Change Pixels Header. Evid: 1129.
 * Event description: Fires when user (client or partner) changes pixels.

 * breakpoint - Type: string. Desc: breakpoint
 *
 * contactId - Type: guid. Desc: contact_id if any
 *
 * device - Type: string. Desc: editorx device
 *
 * editorVersion - Type: string. Desc: {editor/editorx]
 *
 * user_type - Type: string. Desc: user_type
 *
 * mode - Type: string. Desc: {Desktop/Mobile/Tablet}
 *
 * msid - Type: guid. Desc: msid
 * @param {getFeedbackChangePixelsHeaderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackChangePixelsHeader = function (params) {
    return { evid: 1129, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackAddPersonToListParams
* @property {boolean} contactOrNot - true if person added is contact
* @property {GUID} msid - msid
* @property {string} origin - source name
**/
/**
 * Name: Get Feedback - Add Person to list. Evid: 1123.
 * Event description: Fires when user adds someone to the list.

 * contactOrNot - Type: bool. Desc: true if person added is contact
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: source name
 * @param {getFeedbackAddPersonToListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackAddPersonToList = function (params) {
    return { evid: 1123, src: 80, endpoint: 'get-feedback', params: params };
};
/**
* @typedef {Object} getFeedbackSiteSelectorDialogClosedParams

**/
/**
 * Name: Get feedback - site selector dialog closed. Evid: 1118.
 * Event description: clicked to close site selector get feedback dialog.


 * @param {getFeedbackSiteSelectorDialogClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getFeedbackSiteSelectorDialogClosed = function (params) {
    return { evid: 1118, src: 80, endpoint: 'get-feedback', params: params };
};
//# sourceMappingURL=index.js.map